(() => {
  if (customElements.get('testimonials-slider')) {
    return;
  }

  class TestimonialsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.sliderOptions = {};
      this.counterCurrent = this.querySelector('.js-counter-current');

      this.addEventListener('click', (e) => {
        if (this.slider.animating) return;

        const isNext = e.target.hasAttribute('data-overlay-next');
        const isPrev = e.target.hasAttribute('data-overlay-prev');

        if (isNext) {
          this.advanceToNextSlide(e);
        } else if (isPrev) {
          this.advanceToPrevSlide(e);
        }
      });
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.sliderOptions = {
        effect: 'fade',
        rewind: true,
        speed: 1200,
        autoHeight: true,
        calculateHeight: true,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: 1,
        spaceBetween: 24,
        breakpoints: {
          750: {
            allowTouchMove: false,
          },
        },
      };
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.sliderOptions,
      );

      if (!this.counterCurrent) return;

      this.slider.on('slideChange', () => {
        const index = this.slider.realIndex + 1;

        this.counterCurrent.textContent = index >= 10 ? index : `0${index}`;
      });
    }

    advanceToNextSlide(e) {
      e.preventDefault();
      if (!this.slider) return;
      this.slider.slideNext();
    }

    advanceToPrevSlide(e) {
      e.preventDefault();
      if (!this.slider) return;
      this.slider.slidePrev();
    }
  }

  customElements.define('testimonials-slider', TestimonialsSlider);
})();
